<template>
    <div class="time-tag"

    >
        <div class="count-down-box" v-if="!countDownShow">
            {{getCountDown()}}
        </div>
        <div v-if="countDownShow">已超时</div>
    </div>
</template>

<script>
  import { TimeDown } from '@/utils/common';

  export default {
    name: 'countDown',
    props: {
      countDown: {
        type: Number, // 倒计时, 秒
        default: 0,
      }
    },
    data() {
      return {
        selfCountDown: null,
        timeId: null,
      };
    },
    created() {
      this.timeId = setInterval(() => {
        if (this.selfCountDown > 0) {
          this.selfCountDown--;
        } else {
          clearInterval(this.timeId);
        }
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.timeId);
    },
    watch:{
      countDown(newValue){
        this.selfCountDown = newValue
      }
    },
    computed: {
      countDownShow(){
        return this.selfCountDown !==null && this.selfCountDown <= 0;
      }
    },
    methods: {
      getCountDown() {
        return TimeDown(this.selfCountDown);
      }
    }
  };
</script>

<style lang="scss" scoped>
.time-tag {
  display: inline-block;
  margin-left: 10px;
  color: red;
}
</style>
